import {Node} from '../../node/node.mjs';
import {TokenName} from './lexical.mjs';
import {NodeName} from './nodeName.mjs';
import {lineNumber, syntaxError, consumeHeadingContent} from './rulesUtils.mjs';

const PAGE_ID = /^[A-Za-z0-9][A-Za-z0-9_-]*$/;
// Reserve a spaced dash for IDs, including incomplete delimiters at either end.
const PAGE_ID_DELIMITER = /[\t ]+-[\t ]+|[\t ]+-$|^-[\t ]+|^-$/;

class PageName {
    consume(tokenIterator, nodeIterator) {
        if (tokenIterator.token().name !== TokenName.PAGE_NAME) return;
        const line = lineNumber(tokenIterator);
        if (nodeIterator.currentParentNode.name !== NodeName.UNIT) {
            throw syntaxError(line, 'A page must follow a unit title');
        }

        const content = consumeHeadingContent(tokenIterator);
        const delimiter = PAGE_ID_DELIMITER.exec(content);
        const id = delimiter ? content.slice(0, delimiter.index).trim() : null;
        const name = (delimiter ? content.slice(delimiter.index + delimiter[0].length) : content).trim();
        if (id !== null && !PAGE_ID.test(id)) {
            throw syntaxError(line, 'Page ID must start with a letter or digit and contain only letters, digits, underscores or hyphens');
        }
        if (!name) throw syntaxError(line, 'Page name is required');

        nodeIterator.addClosedNode(new Node(NodeName.PAGE, {id, name}, null, nodeIterator.currentParentNode));
    }
}

export {PageName};
